export default __webpack_public_path__ + "static/media/WorkFusion.4f36f765.png";